import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode'; // Correct import
import './App.css';
import Header from './components/Header';
import Cards from './components/Cards';
import Dashboard from './components/Dashboard';
import Historical from './Historical Components/Historical';
import HDImpact from './HD Impact/HDImpactDashboard';
import CitizenImpact from './Citizen Impact/CitizenImpactDashboard';
import Map2 from './Map2/SchemeDashboard';
import ClientFilter from './ClientFilter/ClientDashboard';
import AllFilters from './AllFilters/AllFilterDashboard';
import MSMEImpact from './MSME Impact/MsmeImpactDashboard';
import GoogleLogin from './LoginCredential/GoogleLogin';
import axios from 'axios';
import { logUserLogin } from "./components/logEvents";
import { useLocation } from "react-router-dom";
import { logPageVisit } from "./components/trackEvents";


const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [authorizedEmails, setAuthorizedEmails] = useState([]);

  useEffect(() => {
    fetchAuthorizedEmails(); // Fetch the authorized emails from the backend
  }, []);
  const PageTracker = ({ children, userEmail }) => {
    const location = useLocation();
  
    useEffect(() => {
      if (userEmail) {
        logPageVisit(userEmail, location.pathname);
      }
    }, [location, userEmail]);
  
    return children;
  };
  
  useEffect(() => {
    const storedLogin = localStorage.getItem('isLoggedIn');
    const storedAuthorization = localStorage.getItem('isAuthorized') === 'true';

    setIsLoggedIn(storedLogin === 'true');
    setIsAuthorized(storedAuthorization);

    if (storedLogin === 'true') {
      setupAutoLogoutTimers();
    }
  }, []);

  const fetchAuthorizedEmails = async () => {
    try {
      const response = await axios.get('https://api-salesadmin.haqdarshak.com/api/users/sales-dashboard');
      setAuthorizedEmails(response.data); // Store emails in state
    } catch (error) {
      console.error('Error fetching authorized emails:', error);
    }
  };

  const setupAutoLogoutTimers = () => {
    setTimeout(() => {
      handleLogout();
    }, 2 * 60 * 60 * 1000); // 2 hours

    const handleActivity = () => {
      clearTimeout(window.inactivityTimer);
      window.inactivityTimer = setTimeout(() => {
        handleLogout();
      }, 15 * 60 * 1000); // 15 minutes
    };

    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keypress', handleActivity);

    return () => {
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keypress', handleActivity);
      clearTimeout(window.inactivityTimer);
    };
  };

  const handleGoogleSuccess = (response) => {
    try {
      const decoded = jwtDecode(response.credential);
      console.log('Login successful:', decoded);

      const userEmail = decoded.email;
            // Log login event to Firestore
            logUserLogin(userEmail);

      setIsLoggedIn(true);
      setUserDetails(decoded);

      const authorized = authorizedEmails.includes(userEmail);
      setIsAuthorized(authorized);

      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('isAuthorized', authorized ? 'true' : 'false');

      setupAutoLogoutTimers();
    } catch (error) {
      console.error('Failed to decode Google credential:', error);
    }
  };

  const handleGoogleFailure = (error) => {
    console.error('Login failed:', error);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserDetails(null);
    setIsAuthorized(false);
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('isAuthorized');
    sessionStorage.clear();

    if (window.inactivityTimer) clearTimeout(window.inactivityTimer);
  };

  return (
    <GoogleOAuthProvider clientId="555335856204-5pnk4cv225loruelbffkhjft659te6dq.apps.googleusercontent.com">
      <Router>
        <div className="app">
          {!isLoggedIn ? (
            <GoogleLogin
              onLoginSuccess={handleGoogleSuccess}
              onLoginFailure={handleGoogleFailure}
            />
          ) : (
            <>
              <Header handleLogout={handleLogout} />
  
              {/* Put PageTracker HERE inside Router */}
              <PageTracker userEmail={userDetails?.email}>
                <Routes>
                  <Route
                    path="/"
                    element={
                      isAuthorized ? (
                        <>
                          <Cards />
                          <Dashboard />
                        </>
                      ) : (
                        <div>
                          <h2>Access Denied</h2>
                          <p>You do not have access to this dashboard. Please reach out to data@haqdarshak.com if you need access.</p>
                        </div>
                      )
                    }
                  />
  
                  <Route path="/historical" element={isAuthorized ? <Historical /> : <p>Access Denied</p>} />
                  <Route path="/hd-impact" element={isAuthorized ? <HDImpact /> : <p>Access Denied</p>} />
                  <Route path="/citizen-impact" element={isAuthorized ? <CitizenImpact /> : <p>Access Denied</p>} />
                  <Route path="/map2" element={isAuthorized ? <Map2 /> : <p>Access Denied</p>} />
                  <Route path="/clientfilter" element={isAuthorized ? <ClientFilter /> : <p>Access Denied</p>} />
                  <Route path="/allfilters" element={isAuthorized ? <AllFilters /> : <p>Access Denied</p>} />
                  <Route path="/msme-impact" element={isAuthorized ? <MSMEImpact /> : <p>Access Denied</p>} />
                </Routes>
              </PageTracker>
            </>
          )}
        </div>
      </Router>
    </GoogleOAuthProvider>
  );
  
};

export default App;
